import React from 'react';

import Style from './CardBadge.scss';

/**
 * Display an icon with padding
 */
interface BadgeProps {
  iconImg: string;
}

const CardBadge: React.FC<BadgeProps> = ({ iconImg }) => {
  const bgImgStyle = { backgroundImage: `url(${iconImg})` };
  return <div className={Style.cardBadgeImg} style={bgImgStyle} />;
};

export default CardBadge;
